import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";

export default function ResetPassword() {
    const [params] = useSearchParams();
    const navigate = useNavigate();
    const token = params.get("token") || "";
    const [pw, setPw] = useState("");
    const [pw2, setPw2] = useState("");
    const [busy, setBusy] = useState(false);
    const [done, setDone] = useState(false);
    const [error, setError] = useState("");

    const submit = async (e) => {
        e.preventDefault();
        setError("");
        if (pw.length < 8) return setError("Password must be at least 8 characters");
        if (pw !== pw2) return setError("Passwords don't match");
        setBusy(true);
        try {
            await api.post("/auth/reset-password", { token, password: pw });
            setDone(true);
            toast.success("Password reset — you can log in now");
            setTimeout(() => navigate("/login"), 1800);
        } catch (err) {
            setError(err?.response?.data?.detail || "Could not reset password");
        } finally { setBusy(false); }
    };

    if (!token) {
        return (
            <div className="max-w-md mx-auto px-6 py-16" data-testid="reset-page">
                <h1 className="font-display text-4xl tracking-wide">Invalid link</h1>
                <p className="text-sm text-[#a0a0a0] mt-3">This reset link is missing its token. <Link to="/forgot-password" className="text-[#ff4500] hover:underline">Request a new one</Link>.</p>
            </div>
        );
    }

    return (
        <div className="max-w-md mx-auto px-6 py-16" data-testid="reset-page">
            <div className="text-[#ff4500] text-xs uppercase tracking-[0.3em] mb-2">Account</div>
            <h1 className="font-display text-5xl tracking-wide">New password</h1>
            {done ? (
                <div className="mt-8 border border-[#22c55e]/40 bg-[#22c55e]/10 p-6 text-sm text-[#cfcfcf]" data-testid="reset-done">Your password has been reset. Redirecting to log in…</div>
            ) : (
                <form onSubmit={submit} className="mt-8 space-y-4" data-testid="reset-form">
                    <div>
                        <Label className="text-xs uppercase tracking-[0.2em] text-[#a0a0a0]">New password</Label>
                        <Input data-testid="reset-password" type="password" required value={pw} onChange={(e) => setPw(e.target.value)} className="mt-2 h-12 rounded-none bg-[#141414] border-[#2a2a2a]" />
                    </div>
                    <div>
                        <Label className="text-xs uppercase tracking-[0.2em] text-[#a0a0a0]">Confirm password</Label>
                        <Input data-testid="reset-password-confirm" type="password" required value={pw2} onChange={(e) => setPw2(e.target.value)} className="mt-2 h-12 rounded-none bg-[#141414] border-[#2a2a2a]" />
                    </div>
                    {error && <div data-testid="reset-error" className="text-sm text-[#ff4500] border border-[#ff4500] p-3">{error}</div>}
                    <Button type="submit" data-testid="reset-submit" disabled={busy} className="w-full h-12 rounded-none bg-[#ff4500] hover:bg-[#ff5722] uppercase tracking-[0.2em] text-xs font-semibold">{busy ? "Saving…" : "Set new password"}</Button>
                </form>
            )}
        </div>
    );
}
